import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useState } from "react";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { useResizeObserver } from "./auth-service-tools544.js";
const Corner = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    style,
    ...others
  } = props;
  const ctx = useScrollAreaContext();
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const hasSize = Boolean(width && height);
  useResizeObserver(ctx.scrollbarX, () => {
    var _a;

    const h = ((_a = ctx.scrollbarX) == null ? void 0 : _a.offsetHeight) || 0;
    ctx.onCornerHeightChange(h);
    setHeight(h);
  });
  useResizeObserver(ctx.scrollbarY, () => {
    var _a;

    const w = ((_a = ctx.scrollbarY) == null ? void 0 : _a.offsetWidth) || 0;
    ctx.onCornerWidthChange(w);
    setWidth(w);
  });
  return hasSize ? /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...others,
    ref,
    style: { ...style,
      width,
      height
    }
  }) : null;
});
const ScrollAreaCorner = /*#__PURE__*/forwardRef((props, ref) => {
  const ctx = useScrollAreaContext();
  const hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
  const hasCorner = ctx.type !== "scroll" && hasBothScrollbarsVisible;
  return hasCorner ? /* @__PURE__ */jsxRuntimeExports.jsx(Corner, { ...props,
    ref
  }) : null;
});
export { Corner, ScrollAreaCorner };